"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Basic = _interopRequireDefault(require("./templates/Basic"));
var _Destination = _interopRequireDefault(require("./templates/Destination"));
var _DestinationWide = _interopRequireDefault(require("./templates/DestinationWide"));
var _DestinationVideo = _interopRequireDefault(require("./templates/DestinationVideo"));
var _Banner = _interopRequireDefault(require("./templates/Banner"));
var _Horizontal = _interopRequireDefault(require("./templates/Horizontal"));
var _VerticalSplit = _interopRequireDefault(require("./templates/VerticalSplit"));
var _Video = _interopRequireDefault(require("./templates/Video"));
var _Quote = _interopRequireDefault(require("./templates/Quote"));
var _SignUp = _interopRequireDefault(require("./templates/SignUp"));
var _Svg = _interopRequireDefault(require("../../../Svg/Svg"));
var _constants = require("../../../constants");
var templates = {
  Basic: _Basic["default"],
  Destination: _Destination["default"],
  DestinationWide: _DestinationWide["default"],
  DestinationVideo: _DestinationVideo["default"],
  Banner: _Banner["default"],
  Horizontal: _Horizontal["default"],
  VerticalSplit: _VerticalSplit["default"],
  Quote: _Quote["default"],
  Video: _Video["default"],
  SignUp: _SignUp["default"]
};
var ImageCard = function ImageCard(props) {
  var ImageCardTemplateSelected = templates[props.imageCardTemplate];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card--image height-100%"
  }, props.icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "image__icon"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    className: "icon--md",
    name: props.icon,
    fill: _constants.COLORS.WHITE
  })), /*#__PURE__*/_react["default"].createElement(ImageCardTemplateSelected, props));
};
ImageCard.propTypes = {
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  size: _propTypes["default"].string,
  cta: _propTypes["default"].object,
  whiteFont: _propTypes["default"].bool,
  collapsed: _propTypes["default"].bool,
  imageCardTemplate: _propTypes["default"].string,
  icon: _propTypes["default"].string
};
ImageCard.defaultProps = {
  imageCardTemplate: 'Basic'
};
var _default = exports["default"] = ImageCard;